<template>
<div class="forget-screen">
	<div class="log-body no-required">

    <a class="back-to-login" @click="$service.buriedPoint.goLogin('forget_password_back', true)"><i class="el-icon-arrow-left"></i>返回</a>

		<el-form :model="dataModel" label-position="top" :rules="rules" ref="dataForm" class="left">
			<div class="login-title">忘记密码</div>

			<el-form-item label="账号" prop="mobile_phone" :required="false">
				<el-input v-model.trim="dataModel.mobile_phone" :maxlength="11" autofocus @keyup.enter.native="formSubmit" name="mobile_phone" placeholder="请填写手机号"></el-input>
			</el-form-item>

			<el-form-item label="验证码" prop="code" class="code-group">
				<el-input v-model.trim="dataModel.code" :maxlength="6" @keyup.enter.native="formSubmit" name="code" placeholder="请输入验证码"></el-input>
				<el-button type="primary" class="common-button code-btn" @click="getCode" :disabled="codeAble">获取验证码</el-button>
			</el-form-item>

			<div class="forget-tip" v-show="ds60> 0 && ds60<= 60">验证码已发出，请注意查收短信，<span>{{ds60> 60? 60: ds60}}</span>秒后可重新发送</div>

			<el-form-item label="新密码" prop="passwd" style="margin-bottom:18px">
				<el-input v-model.trim="dataModel.passwd" :maxlength="20" @keyup.enter.native="formSubmit" name="passwd" placeholder="输入6-20位新密码"></el-input>
			</el-form-item>

			<el-button type="primary" @click="formSubmit" class="login-btn">提交</el-button>

		</el-form>

		<div class="right">

		</div>
	</div>

	<div class="login-footer">
		Powered by 上上签 © 2016-2019
	</div>

</div>
</template>

<script>
import { mapMutations } from 'vuex';
import md5 from 'md5';
import utils from '../libs/utils';
import Http from '../libs/http';

const { extend } = utils;

export default {
  data() {
    return {
      dataModel: {
        mobile_phone: localStorage.getItem('username') || '',
        passwd: '',
      },
      remember: !!localStorage.getItem('password'),
      pop: false,
      rules: {
        mobile_phone: [
          { required: true, trigger: 'blur', message: '请输入账号' },
          { pattern: /^1\d{10}$/, trigger: 'blur', message: '请输入正确的账号' },
        ],
        code: [
          { required: true, trigger: 'blur', message: '请输入验证码' },
        ],
        passwd: [
          { required: true, trigger: 'blur', message: '请输入密码' },
          { min: 6, trigger: 'blur', message: '请输入正确的密码' },
        ],
      },
      ds60: 0,
      userData: {},
    };
  },
  computed: {
    passwdEx() {
      return md5(this.dataModel.passwd);
    },
    codeAble() {
      if (this.ds60 > 0) return true;
      return !(/^1\d{10}$/.test(this.dataModel.mobile_phone));
    },
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    getCode() {
      this.ds60 = 100;

      Http.post('/sys/sys_verify_code_get', {
        mobile_phone: this.dataModel.mobile_phone,
        action: 1,
      }, { noToast: true }).then(() => {
        this.ds60 = 60;

        const itv = setInterval(() => {
          if (!--this.ds60) {
            clearInterval(itv);
          }
        }, 1000);
      }).catch((err) => {
        this.ds60 = -1;

        if (err.ret === -2) {
          return utils.msgbox.confirm('该手机号尚未开通同业账号，是否开通？', '账号未开通', {
            confirmButtonText: '立即开通',
            cancelButtonText: '　取消　',
            type: 'warning',
          }).then(() => {
            this.SHOW_LOGIN_BOX({ page: 5 });
          }).catch((e) => {
            if (e) console.log(e);
          });
        }

        utils.msg.error(err.msg);
      });
    },
    formSubmit() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          const postData = extend({}, this.dataModel, {
            passwd: this.passwdEx,
          });

          Http.post('/sys/peer_passwd_reset', postData).then(() => {
            utils.msg.success('修改成功');
            this.$router.replace({ name: 'login', query: { redirect: '/', from: 'modify_password_success' } });
          }).catch((e) => {
            if (e) console.log(e);
          });
        }
      });
    },
  },
};
</script>

<style lang="less">
 @import  '../assets/less/variable';

.forget-screen{
	position:fixed;
	z-index:1;
	top:60px;
	left:0;
	right:0;
	bottom:0;
	min-height:600px;
	background:url(../assets/imgs/login.png) no-repeat center bottom;
	padding-top: 95px;

	.back-to-login {
		font-size: 14px;
		color: @main;
		margin-top: 12px;
		margin-left: 10px;

		i{
			transform: scale(0.83);
			margin-right: 2px;
		}
	}

	.login-title{
		color:#777;
		font-size:20px;
		padding-right:83px;
		text-align:center;
		margin-bottom:40px;
	}

	.forget-tip{
		font-size:12px;
		color:#777;
		margin-top:-5px;
		margin-bottom:22px;
	}

	.log-body{
		box-shadow:0 1px 7px -3px #555;
		width: 800px;
		height: 464px;
		margin:0 auto;
		background-color: #fff;
		position: relative;
		border-radius:4px;

		&>*{
			position: absolute;
		}
		.left{
			width: 466px;
			left:0;
			top:38px;
			padding-left: 83px;
			font-size: 14px;
			color:#777;
			p{
				height:30px;
				line-height: 30px;
			}
		}

		.right{
			background:url(../assets/imgs/slogan.png) no-repeat center center;
			background-size:180px 210px;
			top:0;
			bottom:0;
			right:0;
			width:334px;
			border-left:1px dashed #ececec;
		}

		.el-input__inner{
			width: 300px;
			height:40px;
		}
		.login-btn{
			margin-top: 30px;
			display: block;
			width: 300px;
			height:40px;
			font-size:16px;
		}
	}
	.pop-wrap{
		.el-dialog{
			top:20%!important;
		}
		.el-button{
			width: 240px;
			height:40px;
			font-size: 16px;
			margin:15px auto 0 auto;
			display:block;
		}
		.content-wrap{
			margin:auto;
			height:320px;
			overflow-y: auto;
			padding:0 42px;
			.content{
				text-indent: 20px;
				font-size: 12px;
				margin-top: 8px;
				line-height: 19px;
				font-size: 12px;
				margin-bottom: 19px
			}
		}
	}

	.code-group{
		.code-btn{
			width:76px;
			height:38px;
			font-size:12px;
			position:absolute;
			padding:0;
			text-align:center;
			line-height:38px;
			top:1px;
			right:84px;
			border-radius: 3px;
			border-top-left-radius:0;
			border-bottom-left-radius:0;
			background-color: #2f333f;
			border-color: #2f333f;
		}
	}

	.login-footer{
		text-align:center;
		font-size:12px;
		color:#aaa;
		margin-top:22px;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/Forget.vue